import { useMutation, useQueryClient } from '@tanstack/react-query';
import { TransportersApi } from 'api';

/**
 * Custom React Query hook that handles the creation of carriers.
 *
 * @param {"single" | "batch"} type
 * @param {{ onSuccess?: () => void; onError?: (error: Error) => void }} options
 * @returns {import('@tanstack/react-query').UseMutationResult<any, unknown, any, unknown>}
 */
export function useCreateTransporters(type = 'single', { onSuccess, onError } = {}) {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (data) => {
      if (type === 'batch') {
        return TransportersApi.batchAdd(data);
      }

      return TransportersApi.add(data);
    },
    onSuccess: (res) => {
      queryClient.invalidateQueries(['transporters']);
      typeof onSuccess === 'function' && onSuccess(res.data);
    },
    onError: (error) => {
      typeof onError === 'function' && onError(error);
    },
  });
}
